// src/config/taxYearNotice.ts
// הערת שנת המס שמוצגת בראש כל דף תוצאות (16 מחשבונים), בהיסטוריה ובהדפסה.
//
// עדכון שנתי (ינואר 2027 וכו'): לשנות את TAX_YEAR (ואת הנוסח אם נדרש), build + deploy.
// חישובים שנשמרו לפני השינוי ממשיכים להציג את הטקסט שנשמר איתם
// (snapshot ב-result_data.tax_year_notice, ראה calculatorService.saveCalculation).

/** שנת המס שלפיה המחשבונים מחשבים כרגע */
export const TAX_YEAR = 2026;

/** נוסח ההערה לשנה נתונה — הטקסט המדויק שביקש הלקוח (אוקטובר 2026) */
export const taxYearNoticeForYear = (year: number): string =>
  `החישוב שבוצע הוא בהתאם לשיעור המס לשנת ${year} בלבד.`;

/** נוסח ההערה הנוכחי */
export const TAX_YEAR_NOTICE = taxYearNoticeForYear(TAX_YEAR);

/**
 * ההערה לחישוב שמור: ה-snapshot שנשמר איתו, ואם אין (חישובים שנשמרו לפני
 * אוקטובר 2026) — הנוסח לפי שנת השמירה. מחרוזת ריקה = אין מה להציג.
 *
 * השנה נקראת מ-4 הספרות הראשונות של התאריך ולא דרך new Date(): המחרוזת מגיעה
 * מהשרת (ISO או "YYYY-MM-DD HH:MM:SS") ו-Safari לא מפרסר את הפורמט השני.
 */
export const resolveSavedTaxYearNotice = (
  resultData: Record<string, any> | null | undefined,
  calculationDate: string | null | undefined
): string => {
  const saved = resultData?.tax_year_notice;
  if (typeof saved === "string" && saved.trim()) return saved;
  const year = /^(\d{4})/.exec(calculationDate || "");
  return year ? taxYearNoticeForYear(Number(year[1])) : "";
};
